// frontend/src/components/admin/modules/SystemConfig.js
import { api } from '../../../services/api.js';
import { Notification } from '../../../components/Notification.js';
import moment from 'moment-timezone';

function openSignalModal(signalData = null, container, notificationContainer, onSave) {
    const isEditing = signalData !== null;
    
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'signal-modal-overlay';
    modalOverlay.innerHTML = `
        <div class="signal-modal-content">
            <h3>${isEditing ? 'Editar Señal' : 'Crear Nueva Señal'}</h3>
            <form id="signalForm" class="signal-modal-form">
                <div class="form-group">
                    <label for="signalName">Nombre Descriptivo</label>
                    <input type="text" id="signalName" class="remate-input" value="${signalData?.name || ''}" placeholder="Ej: Video de la 5ta Carrera" required>
                </div>
                <div class="form-group">
                    <label for="signalType">Tipo de Señal</label>
                    <select id="signalType" class="remate-select" required>
                        <option value="url" ${signalData?.type === 'url' ? 'selected' : ''}>URL (Video, Página Web)</option>
                        <option value="text" ${signalData?.type === 'text' ? 'selected' : ''}>Texto (Mensaje)</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="signalContent">Contenido (URL completa o mensaje de texto)</label>
                    <textarea id="signalContent" rows="4" class="remate-input" placeholder="https://www.youtube.com/watch?v=..." required>${signalData ? decodeURIComponent(signalData.content) : ''}</textarea>
                </div>
                <div class="signal-modal-buttons">
                    <button type="button" class="btn btn-secondary" id="cancelSignalForm">Cancelar</button>
                    <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>
    `;

    document.body.appendChild(modalOverlay);

    const closeModal = () => document.body.removeChild(modalOverlay);

    modalOverlay.querySelector('#cancelSignalForm').addEventListener('click', closeModal);
    modalOverlay.querySelector('#signalForm').addEventListener('submit', async (e) => {
        e.preventDefault();
        const form = e.target;
        const payload = {
            name: form.querySelector('#signalName').value,
            type: form.querySelector('#signalType').value,
            content: form.querySelector('#signalContent').value,
        };

        try {
            if (isEditing) {
                await api.put(`/signals/${signalData.id}`, payload);
                Notification(notificationContainer, 'Señal actualizada exitosamente.', 'success');
            } else {
                await api.post('/signals', payload);
                Notification(notificationContainer, 'Señal creada exitosamente.', 'success');
            }
            closeModal();
            onSave();
        } catch (error) {
             Notification(notificationContainer, error.message || 'Error al guardar la señal.', 'error');
        }
    });
}

export async function renderGlobalConfig(container, notificationContainer) {
    container.innerHTML = `
        <div class="my-4 p-4 border rounded-lg" style="background: #1e293b; border-color: #334155;">
            <h5 class="font-bold text-lg mb-3" style="color: #D4AF37;">🔢 Porcentaje de la Casa (Retención)</h5>
            <p class="text-sm text-gray-400 mb-2">Este porcentaje se restará automáticamente del "Total Tabla" para calcular el "Pote" a repartir en la App de Remates.</p>
            <div class="flex gap-4 items-center">
                <input type="number" id="housePercent" class="remate-input w-32" placeholder="Ej: 25" min="0" max="100">
                <span class="font-bold text-xl">%</span>
                <button id="savePercentBtn" class="btn btn-primary">Guardar Porcentaje</button>
            </div>
        </div>

        <div class="my-4 p-4 border rounded-lg" style="background: #1e293b; border-color: #334155;">
            <h5 class="font-bold text-lg mb-3" style="color: #D4AF37;">💵 Tasa de Cambio (Bolívares por Dólar)</h5>
            <p class="text-sm text-gray-400 mb-2">Esta tasa se usará en la App de Remate para calcular equivalencias entre USD y Bs.</p>
            <div class="flex gap-4 items-center">
                <input type="number" id="exchangeRate" class="remate-input w-48" placeholder="Ej: 45.50" step="0.01" min="0">
                <span class="font-bold text-xl">Bs/$</span>
                <button id="saveExchangeRateBtn" class="btn btn-success">Actualizar Tasa</button>
            </div>
        </div>

        <div class="my-4 p-4 border rounded-lg" style="background: #1e293b; border-color: #334155;">
            <h5 class="font-bold text-lg mb-3" style="color: #D4AF37;">💳 Información de Pago (Recargas)</h5>
            <p class="text-sm text-gray-400 mb-2">Esta información aparecerá en la App cuando el usuario pulse "Recargar" y seleccione Pago Móvil/Transferencia.</p>
            <textarea id="paymentInfo" rows="5" class="remate-input" placeholder="Ej: Pago Móvil: 0414-1234567, Banco Venezuela..."></textarea>
            <button id="savePaymentInfoBtn" class="btn btn-warning mt-2" style="color: black; font-weight: bold;">Guardar Información</button>
        </div>
    `;

    const housePercentInput = container.querySelector('#housePercent');
    const exchangeRateInput = container.querySelector('#exchangeRate');
    const paymentInfoInput = container.querySelector('#paymentInfo');

    try {
        const configRes = await api.get('/configs/cashier'); 
        const config = Array.isArray(configRes) ? configRes[0] : configRes;
        
        if(config) {
            housePercentInput.value = config.house_retention_percent || 25;
            exchangeRateInput.value = config.exchange_rate || 1;
            paymentInfoInput.value = config.payment_methods_info || '';
        }
    } catch(e) { console.error("Error cargando configuración global:", e); }

    container.querySelector('#savePercentBtn').addEventListener('click', async () => {
        try {
            await api.put('/configs/global', { house_retention_percent: parseFloat(housePercentInput.value) });
            Notification(notificationContainer, 'Porcentaje actualizado correctamente.', 'success');
        } catch(e) { Notification(notificationContainer, 'Error al guardar porcentaje.', 'error'); }
    });

    container.querySelector('#saveExchangeRateBtn').addEventListener('click', async () => {
        const rate = parseFloat(exchangeRateInput.value);
        if (!rate || rate <= 0) return Notification(notificationContainer, 'Ingrese una tasa válida.', 'warning');
        
        const btn = container.querySelector('#saveExchangeRateBtn');
        const originalText = btn.innerText;
        btn.innerText = 'Guardando...';
        btn.disabled = true;

        try {
            await api.put('/configs/cashier', { exchange_rate: rate });
            Notification(notificationContainer, `Tasa actualizada a ${rate} Bs/$`, 'success');
        } catch(e) { 
            Notification(notificationContainer, 'Error al guardar la tasa.', 'error'); 
        } finally {
            btn.innerText = originalText;
            btn.disabled = false;
        }
    });

    container.querySelector('#savePaymentInfoBtn').addEventListener('click', async () => {
        try {
            await api.put('/configs/global', { payment_methods_info: paymentInfoInput.value });
            Notification(notificationContainer, 'Información de pago actualizada.', 'success');
        } catch(e) { Notification(notificationContainer, 'Error al guardar Info de Pago.', 'error'); }
    });
}

export async function renderSignalsManagement(container, notificationContainer) {
    container.innerHTML = `
        <h4>Lista de Señales</h4>
        <p>Estas señales estarán disponibles para que los cajeros las envíen a las pantallas conectadas.</p>
        <button class="btn btn-primary" id="createSignalBtn">Crear Nueva Señal</button>
        <table class="table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Nombre</th>
                    <th>Tipo</th>
                    <th>Contenido</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody id="signalsTableBody"></tbody>
        </table>
    `;

    const signalsTableBody = container.querySelector('#signalsTableBody');
    const createSignalBtn = container.querySelector('#createSignalBtn');

    const fetchSignals = async () => {
        try {
            const signals = await api.get('/signals');
            signalsTableBody.innerHTML = signals.map(signal => `
                <tr>
                    <td>${signal.id}</td>
                    <td>${signal.name}</td>
                    <td>${signal.type.toUpperCase()}</td>
                    <td style="max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${signal.content}</td>
                    <td>
                        <button class="btn btn-warning btn-sm edit-signal-btn" data-id="${signal.id}" data-name="${signal.name}" data-type="${signal.type}" data-content="${encodeURIComponent(signal.content)}">Editar</button>
                        <button class="btn btn-danger btn-sm delete-signal-btn" data-id="${signal.id}">Eliminar</button>
                    </td>
                </tr>
            `).join('');

            signalsTableBody.querySelectorAll('.edit-signal-btn').forEach(btn => {
                btn.addEventListener('click', () => openSignalModal(btn.dataset, container, notificationContainer, fetchSignals));
            });

            signalsTableBody.querySelectorAll('.delete-signal-btn').forEach(btn => {
                btn.addEventListener('click', async () => {
                    if (confirm('¿Estás seguro de que quieres eliminar esta señal?')) {
                        try {
                            await api.delete(`/signals/${btn.dataset.id}`);
                            Notification(notificationContainer, 'Señal eliminada exitosamente.', 'success');
                            fetchSignals();
                        } catch (error) {
                            Notification(notificationContainer, error.message || 'Error al eliminar la señal.', 'error');
                        }
                    }
                });
            });
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cargar las señales.', 'error');
        }
    };

    createSignalBtn.addEventListener('click', () => openSignalModal(null, container, notificationContainer, fetchSignals));

    await fetchSignals();
}

export function renderAppInstaller(container, notificationContainer) {
    container.innerHTML = `
        <div style="background:#1e293b; padding:20px; border-radius:10px; border:1px solid #334155; max-width: 800px; margin: 0 auto;">
            <h4 class="text-2xl font-bold mb-2 border-b pb-2" style="color: #D4AF37;">📱 Instalación de App Móvil</h4>
            <p class="text-gray-400 mb-6">
                Utilice este código QR para instalar el acceso directo en los dispositivos de los clientes o taquillas.
                Al escanearlo, el sistema ofrecerá la opción de "Instalar App" para una experiencia de pantalla completa.
            </p>

            <div class="flex flex-col md:flex-row items-center gap-8 justify-center">
                <div class="flex flex-col items-center">
                    <div id="app-qr-container" class="p-4 bg-white border-4 border-gray-800 rounded-lg shadow-lg mb-4">
                        </div>
                    <span class="text-sm font-bold text-gray-500">Escanea con la cámara</span>
                </div>

                <div class="flex flex-col gap-4 w-full md:w-auto">
                    <div style="background: #0f172a; padding: 15px; border-radius: 8px; border: 1px solid #334155;">
                        <strong style="color: #D4AF37; display: block; margin-bottom: 5px;">Enlace Directo:</strong>
                        <code id="appUrlDisplay" class="block bg-gray-800 p-2 rounded border text-xs text-gray-300 break-all">...</code>
                    </div>

                    <button id="downloadQrBtn" class="btn btn-success w-full font-bold py-3 flex items-center justify-center gap-2">
                        💾 Descargar Imagen QR
                    </button>
                    
                    <button id="copyLinkBtn" class="btn btn-primary w-full font-bold py-3 flex items-center justify-center gap-2">
                        🔗 Copiar Enlace
                    </button>
                    
                    <button id="shareBtn" class="btn btn-warning w-full font-bold py-3 flex items-center justify-center gap-2 hidden">
                        📤 Compartir
                    </button>
                </div>
            </div>
        </div>
    `;

    const currentUserData = JSON.parse(localStorage.getItem('user')) || { username: 'Operador' };
    const appUrl = window.location.origin + "/api/descargar-app?operator=" + encodeURIComponent(currentUserData.username);
    const qrContainer = container.querySelector('#app-qr-container');
    container.querySelector('#appUrlDisplay').textContent = appUrl;

    const generateQR = () => {
        qrContainer.innerHTML = '';
        const qrSize = 250;
        const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${qrSize}x${qrSize}&data=${encodeURIComponent(appUrl)}&margin=10`;
        
        const img = document.createElement('img');
        img.src = qrApiUrl;
        img.alt = "QR App Taquilla";
        img.style.maxWidth = "100%";
        qrContainer.appendChild(img);

        return img;
    };

    const qrImage = generateQR();

    container.querySelector('#downloadQrBtn').addEventListener('click', async () => {
        try {
            const response = await fetch(qrImage.src);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = "TaquillaHipica_App_QR.png";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            Notification(notificationContainer, 'QR Descargado.', 'success');
        } catch (e) {
            Notification(notificationContainer, 'Error al descargar. Intente guardar la imagen manualmente.', 'error');
        }
    });

    container.querySelector('#copyLinkBtn').addEventListener('click', () => {
        navigator.clipboard.writeText(appUrl).then(() => {
            Notification(notificationContainer, 'Enlace copiado al portapapeles.', 'success');
        });
    });

    const shareBtn = container.querySelector('#shareBtn');
    if (navigator.share) {
        shareBtn.classList.remove('hidden');
        shareBtn.addEventListener('click', () => {
            navigator.share({
                title: 'Instalar Taquilla Hípica',
                text: 'Accede al sistema de taquilla desde este enlace:',
                url: appUrl
            }).catch(console.error);
        });
    }
}

export async function renderProfitReport(container, notificationContainer) {
    container.innerHTML = `
        <div style="background:#1e293b; padding:15px; border-radius:8px; border:1px solid #334155; margin-bottom:20px;">
            <h3 style="color:#D4AF37; margin-bottom:15px; border-bottom:1px solid #334155; padding-bottom:10px;">
                📊 Reporte de Liquidación de Remates
            </h3>
            
            <div class="form-grid" style="align-items: end;">
                <div class="form-group">
                    <label>Desde:</label>
                    <input type="date" id="rep-date-from" class="remate-input">
                </div>
                <div class="form-group">
                    <label>Hasta:</label>
                    <input type="date" id="rep-date-to" class="remate-input">
                </div>
                <div class="form-group">
                    <label>Hipódromo:</label>
                    <select id="rep-track-select" class="remate-select">
                        <option value="">Todos</option>
                    </select>
                </div>
                <button id="btn-fetch-report" class="btn-action" style="background:#3b82f6; color:white; font-weight:bold; height: 44px;">
                    📥 Buscar Datos
                </button>
            </div>
            
            <div id="sub-filters" class="hidden" style="display:flex; gap:10px; flex-wrap:wrap; align-items:end; margin-top:15px; border-top:1px dashed #475569; padding-top:15px;">
                <div class="form-group">
                    <label style="color:#D4AF37;">Filtrar Carrera:</label>
                    <select id="rep-race-select" class="remate-select" style="border-color:#D4AF37;">
                        <option value="ALL">Todas las Carreras</option>
                    </select>
                </div>
                <div class="form-group">
                    <label style="color:#D4AF37;">Filtrar Tabla:</label>
                    <select id="rep-table-select" class="remate-select" style="border-color:#D4AF37;">
                        <option value="ALL">Todas las Tablas</option>
                    </select>
                </div>
            </div>
        </div>

        <div style="overflow-x:auto; background:#1e293b; border-radius:8px; border:1px solid #334155;">
            <table class="remate-table" style="width:100%; border-collapse:collapse;">
                <thead>
                    <tr style="background:#0f172a; color:#f8fafc; font-size:0.85rem;">
                        <th style="padding:10px; border-bottom:2px solid #D4AF37;">Fecha / Carrera / Tabla</th>
                        <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:right;">Jugada Total</th>
                        <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:right; color:#4ade80;">% Casa</th>
                        <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:right; color:#fca5a5;">Ejemplares Casa</th>
                        <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:right; color:#60a5fa;">5% Tablazo</th>
                        <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:right; color:#eab308;">Pago Tabla</th>
                        <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:center;">¿Ganó Casa?</th>
                        <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:right; color:#10b981;">Ganancia Casa</th>
                        <th style="padding:10px; border-bottom:2px solid #D4AF37; text-align:right; color:#f59e0b;">Total Ganancia</th> </tr>
                </thead>
                <tbody id="profit-report-body">
                    <tr><td colspan="9" class="text-center" style="padding:20px; color:#94a3b8;">Haga clic en 'Buscar Datos'</td></tr>
                </tbody>
                <tfoot id="profit-report-footer" style="background:#0f172a; font-weight:bold; color:#D4AF37;">
                </tfoot>
            </table>
        </div>
    `;

    const dateFrom = container.querySelector('#rep-date-from');
    const dateTo = container.querySelector('#rep-date-to');
    const trackSel = container.querySelector('#rep-track-select');
    const raceSel = container.querySelector('#rep-race-select');
    const tableSel = container.querySelector('#rep-table-select');
    const btnFetch = container.querySelector('#btn-fetch-report');
    const subFilters = container.querySelector('#sub-filters');
    const tbody = container.querySelector('#profit-report-body');
    const tfoot = container.querySelector('#profit-report-footer');

    let globalReportData = [];

    const today = new Date();
    dateFrom.value = today.toISOString().split('T')[0];
    dateTo.value = today.toISOString().split('T')[0];

    const loadTracks = async () => {
        try {
            const response = await api.get('/tracks?admin_mode=true&_t=' + Date.now()); 
            const tracks = response.tracks || response; 
            
            if (Array.isArray(tracks)) {
                tracks.forEach(t => {
                    const opt = document.createElement('option');
                    opt.value = t.id; opt.innerText = t.name;
                    trackSel.appendChild(opt);
                });
            }
        } catch(e) { console.error("Error cargando tracks", e); }
    };

    const fetchReportData = async () => {
        tbody.innerHTML = '<tr><td colspan="9" class="text-center" style="padding:20px;"><i class="fas fa-spinner fa-spin"></i> Cargando...</td></tr>';
        tfoot.innerHTML = '';
        
        try {
            const params = new URLSearchParams();
            if(dateFrom.value) params.append('from', dateFrom.value);
            if(dateTo.value) params.append('to', dateTo.value);
            if(trackSel.value) params.append('trackId', trackSel.value);

            globalReportData = await api.get(`/remate/reports/profit?${params.toString()}`);
            
            if(globalReportData.length > 0) {
                subFilters.classList.remove('hidden');
                subFilters.style.display = 'flex';
            } else {
                subFilters.classList.add('hidden');
                subFilters.style.display = 'none';
            }

            populateRaceDropdown();
            renderTable();
        } catch (e) {
            tbody.innerHTML = '<tr><td colspan="9" class="text-center text-red-500">Error al cargar datos del servidor.</td></tr>';
        }
    };

    const populateRaceDropdown = () => {
        const races = new Set();
        globalReportData.forEach(r => races.add(r.race_number));
        
        raceSel.innerHTML = '<option value="ALL">Todas las Carreras</option>';
        Array.from(races).sort((a,b) => a-b).forEach(rNum => {
            raceSel.innerHTML += `<option value="${rNum}">Carrera ${rNum}</option>`;
        });
        populateTableDropdown();
    };

    const populateTableDropdown = () => {
        const selectedRace = raceSel.value;
        const tables = new Set();
        
        globalReportData.forEach(r => {
            if (selectedRace === 'ALL' || String(r.race_number) === selectedRace) {
                const tableName = r.room_name.replace('Sala', 'Tabla');
                tables.add(tableName);
            }
        });
        
        tableSel.innerHTML = '<option value="ALL">Todas las Tablas</option>';
        Array.from(tables).sort().forEach(tName => {
            const realRoomName = tName.replace('Tabla', 'Sala');
            tableSel.innerHTML += `<option value="${realRoomName}">${tName}</option>`;
        });
    };

    raceSel.addEventListener('change', () => {
        populateTableDropdown();
        renderTable();
    });

    tableSel.addEventListener('change', renderTable);

    const renderTable = () => {
        const selectedRace = raceSel.value;
        const selectedRoom = tableSel.value;

        const filteredData = globalReportData.filter(r => {
            const matchRace = selectedRace === 'ALL' || String(r.race_number) === selectedRace;
            const matchRoom = selectedRoom === 'ALL' || r.room_name === selectedRoom;
            return matchRace && matchRoom;
        });

        if(filteredData.length === 0) {
            tbody.innerHTML = '<tr><td colspan="9" class="text-center" style="padding:20px;">No hay resultados para estos filtros.</td></tr>';
            tfoot.innerHTML = '';
            return;
        }

        let sJugada = 0, sCasa = 0, sEjCasa = 0, sTablazo = 0, sPago = 0, sGanancia = 0, sGananciaTotal = 0;

        tbody.innerHTML = filteredData.map(row => {
            sJugada += row.total_subasta;
            sCasa += row.house_retention_amount;
            sEjCasa += row.ejemplares_casa;
            sTablazo += row.tablazo_5_percent;
            sPago += row.pago_tabla;
            sGanancia += row.ganancia_casa;
            sGananciaTotal += row.ganancia_total;

            const dateStr = new Date(row.date).toLocaleDateString('es-VE', {day:'2-digit', month:'2-digit'});
            const displayTableName = row.room_name.replace('Sala', 'Tabla');

            return `
                <tr style="border-bottom:1px solid #334155;">
                    <td style="padding:10px; color:#cbd5e1;">
                        <div style="font-weight:bold; color:white;">${row.track_name}</div>
                        <div style="font-size:0.8rem; color:#94a3b8;">${dateStr} - C${row.race_number} (${displayTableName})</div>
                    </td>
                    <td style="padding:10px; text-align:right; font-family:monospace; font-size:1.1rem; color:white;">
                        $${row.total_subasta.toFixed(2)}
                    </td>
                    <td style="padding:10px; text-align:right; font-family:monospace; font-size:1rem; color:#4ade80;">
                        $${row.house_retention_amount.toFixed(2)}
                    </td>
                    <td style="padding:10px; text-align:right; font-family:monospace; font-size:1rem; color:#fca5a5;">
                        $${row.ejemplares_casa.toFixed(2)}
                    </td>
                    <td style="padding:10px; text-align:right; font-family:monospace; font-size:1rem; color:#60a5fa;">
                        $${row.tablazo_5_percent.toFixed(2)}
                    </td>
                    <td style="padding:10px; text-align:right; font-family:monospace; font-weight:bold; font-size:1.1rem; color:#eab308;">
                        $${row.pago_tabla.toFixed(2)}
                    </td>
                    <td style="padding:10px; text-align:center;">
                        <span style="padding:3px 8px; border-radius:4px; font-size:0.8rem; font-weight:bold; ${row.winner_is_house === 'SI' ? 'background:rgba(16, 185, 129, 0.2); color:#4ade80;' : (row.winner_is_house === 'NADIE' ? 'background:rgba(148, 163, 184, 0.2); color:#94a3b8;' : 'background:rgba(239, 68, 68, 0.2); color:#fca5a5;')}">
                            ${row.winner_is_house}
                        </span>
                    </td>
                    <td style="padding:10px; text-align:right; font-family:monospace; font-weight:bold; font-size:1.1rem; ${row.ganancia_casa >= 0 ? 'color:#10b981;' : 'color:#ef4444;'}">
                        ${row.ganancia_casa >= 0 ? '+' : ''}$${row.ganancia_casa.toFixed(2)}
                    </td>
                    <td style="padding:10px; text-align:right; font-family:monospace; font-weight:bold; font-size:1.1rem; ${row.ganancia_total >= 0 ? 'color:#f59e0b;' : 'color:#ef4444;'}">
                        ${row.ganancia_total >= 0 ? '+' : ''}$${row.ganancia_total.toFixed(2)}
                    </td>
                </tr>
            `;
        }).join('');

        tfoot.innerHTML = `
            <tr>
                <td style="padding:15px; text-align:right; color:white;">TOTALES FILTRADOS:</td>
                <td style="padding:15px; text-align:right; font-size:1.2rem; color:white;">$${sJugada.toFixed(2)}</td>
                <td style="padding:15px; text-align:right; font-size:1.1rem; color:#4ade80;">$${sCasa.toFixed(2)}</td>
                <td style="padding:15px; text-align:right; font-size:1.1rem; color:#fca5a5;">$${sEjCasa.toFixed(2)}</td>
                <td style="padding:15px; text-align:right; font-size:1.1rem; color:#60a5fa;">$${sTablazo.toFixed(2)}</td>
                <td style="padding:15px; text-align:right; font-size:1.2rem; color:#eab308;">$${sPago.toFixed(2)}</td>
                <td></td>
                <td style="padding:15px; text-align:right; font-size:1.3rem; ${sGanancia >= 0 ? 'color:#10b981;' : 'color:#ef4444;'}">
                    ${sGanancia >= 0 ? '+' : ''}$${sGanancia.toFixed(2)}
                </td>
                <td style="padding:15px; text-align:right; font-size:1.3rem; ${sGananciaTotal >= 0 ? 'color:#f59e0b;' : 'color:#ef4444;'}">
                    ${sGananciaTotal >= 0 ? '+' : ''}$${sGananciaTotal.toFixed(2)}
                </td>
            </tr>
        `;
    };

    await loadTracks();
    btnFetch.onclick = fetchReportData;
}